import * as React from 'react';
const NotificationIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={20} fill="none" {...props}>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 3a2 2 0 1 1 4 0 7 7 0 0 1 4 6v3a4 4 0 0 0 2 3H1a4 4 0 0 0 2-3V9a7 7 0 0 1 4-6M6 15v1a3 3 0 0 0 6 0v-1"
    />
  </svg>
);
export default NotificationIcon;
